import React from 'react';
import { Button, Flex, Typography } from 'antd';

interface LoadErrorNoticeProps {
  message: string;
  onRetry: () => void;
}

/** A failed load, with a Retry button — so a failure never reads as "nothing here". */
const LoadErrorNotice: React.FC<LoadErrorNoticeProps> = ({
  message,
  onRetry,
}) => (
  <Flex vertical align='flex-start' gap={8} role='alert'>
    <Typography.Text type='danger'>{message}</Typography.Text>
    <Button size='small' onClick={onRetry}>
      Retry
    </Button>
  </Flex>
);

export default LoadErrorNotice;
